import api from '@/services/utils/base';
import store from '@/store';

export default class Tag {
  getList(params?:any) {
    return api.get('tags', {params})
      .then((res: any) => {
        return Promise.resolve(res.data.payload);
      })
      .catch((err: any) => {
        return Promise.reject();
      });
  }
  populateStoreCache(params?:any) {
    return api.get('tags', {params})
      .then((res: any) => {
        store.commit('populateTagsCache', {
          type: params.type,
          data: res.data.payload
        });
        return Promise.resolve(res.data.payload);
      })
      .catch((err: any) => {
        return Promise.reject();
      });
  }
}
